module.exports = __webpack_public_path__ + "img/share-content_en-GB.df555e9c.png";